import * as React from 'react';
import { Tile, TileProps } from 'ui/tile/tile';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';

export interface InvolvedPersonTileProps extends TileProps {
  textNewEntry: string;
  textEgress?: string;
  textNewEntrySuccess?: string;
  textEgressSuccess?: string;
  onAddNewEntry?: () => Promise<any> | void;
  onEgressEntry?: () => Promise<any> | void;
  canAddNewEntry?: boolean;
  isSaving?: boolean;
  extendedButton: {text: string, onClick: () => void};
  disableAddButton?: boolean;
}

/**
 * Tells the user that the change was saved. Nothing is shown when nothing was changed.
 */
const notifySaved = (result: any, message: string) => {
  if (result?.saved) {
    toastFactory().dispatchSuccess(message);
  }
};

export const InvolvedPersonTile: React.FC<InvolvedPersonTileProps> = (props) => {

  const {textNewEntry} = props;

  const handleNewEntry = async () => {
    notifySaved(await props.onAddNewEntry?.(), props.textNewEntrySuccess);
  };

  const handleEgress = async () => {
    notifySaved(await props.onEgressEntry?.(), props.textEgressSuccess);
  };

  // While the person is inside (an entry without egress time exists) the button egresses that entry,
  // otherwise it adds a new entry.
  const extendedButton = props.onEgressEntry ?
    {text: props.textEgress, visible: true, loading: props.isSaving, onClick: handleEgress} :
    props.canAddNewEntry && props.onAddNewEntry ?
      {text: textNewEntry, visible: !props.disableAddButton, loading: props.isSaving, onClick: handleNewEntry} : undefined;

  return <>
    <Tile
      {...props}
      extendedButton={extendedButton} />
  </>;
};
